import * as THREE from 'three'

import Experience from '.'

export default class Renderer {
  private experience = new Experience()

  public instance!: THREE.WebGLRenderer

  constructor() {
    this.removeDomElement()
    this.setInstance()
  }

  private removeDomElement() {
    const canvas = document.querySelector('canvas')
    if (canvas) document.getElementById('experience')?.removeChild(canvas)
  }

  private setInstance() {
    this.instance = new THREE.WebGLRenderer({
      antialias: true,
      // alpha: true,
    })

    this.instance.outputEncoding = THREE.sRGBEncoding

    // this.instance.toneMapping = THREE.LinearToneMapping
    // this.instance.toneMappingExposure = 1.2

    this.instance.setSize(
      this.experience.config.screen.width,
      this.experience.config.screen.height
    )
    this.instance.setPixelRatio(this.experience.config.screen.pixelRatio)
  }

  public resize() {
    this.instance.setSize(
      this.experience.config.screen.width,
      this.experience.config.screen.height
    )
    this.instance.setPixelRatio(this.experience.config.screen.pixelRatio)
  }

  public update() {
    /**
     * On taking a photo add orto cam and scene to display
     * the branding element into the canvas
     */
    this.instance.autoClear = true

    this.instance.render(
      this.experience.scene,
      this.experience.camera.zapparCamera
    )

    this.instance.autoClear = false

    this.instance.clearDepth()

    this.instance.render(
      this.experience.sceneOrtho,
      this.experience.camera.orthoCamera
    )
  }
}
